module.exports = __webpack_public_path__ + "static/assets/15673472d553b3fdcb9fc334489d0f9d.svg";